import type { RootThunkDispatch } from 'store'
import type {
  AuthenticateRequestBody,
  RegisterRequestBody,
} from 'services/sso/types'
import {
  FETCHED,
  LOCATION_FETCHED,
  LOGOUT,
  FETCHED_IS_REGISTERED_FOR_ONRAMP,
} from './actionTypes'
import cookies from 'services/cookies'
import * as lmsApi from 'services/lms'
import * as ssoApi from 'services/sso'
import * as locationApi from 'services/location'

export function logout() {
  return async (dispatch: RootThunkDispatch) => {
    cookies.logout()
    dispatch({
      type: LOGOUT,
    })
    await ssoApi.logout()
    fetchUser()(dispatch)
  }
}

export function authenticate(params: AuthenticateRequestBody) {
  return async (dispatch: RootThunkDispatch) => {
    const result = await ssoApi.authenticate(params)
    cookies.saveAccessToken(result.accessToken)
    cookies.removeLocation()
    fetchUser()(dispatch)
  }
}

export function register(params: RegisterRequestBody) {
  return async (dispatch: RootThunkDispatch) => {
    await ssoApi.register(params)
    return authenticate(params)(dispatch)
  }
}

export function fetchUser() {
  return async (dispatch: RootThunkDispatch) => {
    await fetchUserToken()(dispatch)
    fetchLocation()(dispatch)
  }
}

function fetchUserToken() {
  return async (dispatch: RootThunkDispatch) => {
    try {
      const user = await ssoApi.fetchUser()

      if (user) {
        dispatch({
          type: FETCHED,
          payload: user,
        })

        const isRegisteredForOnRamp = await lmsApi.fetchIsRegisteredForOnRamp()

        dispatch({
          type: FETCHED_IS_REGISTERED_FOR_ONRAMP,
          payload: isRegisteredForOnRamp,
        })
      }
    } catch (error) {
      cookies.logout()
    }
  }
}

function fetchLocation() {
  return async (dispatch: RootThunkDispatch) => {
    const cookieLocation = cookies.getLocation()

    if (cookieLocation) {
      dispatch({
        type: LOCATION_FETCHED,
        payload: cookieLocation,
      })
    } else {
      const location = await locationApi.fetchLocation()

      if (location) {
        cookies.saveLocation(location)

        dispatch({
          type: LOCATION_FETCHED,
          payload: location,
        })
      }
    }
  }
}
